import { Navigate } from "react-router-dom";
import { authService } from "../services";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const isAuthenticated = authService.isAuthenticated();
  const currentUser = authService.getCurrentUser();

  // console.log("🔐 ProtectedRoute Check:", {
  //   isAuthenticated,
  //   userRole: currentUser?.role,
  //   userCompanyId: currentUser?.companyId, // NEW
  //   allowedRoles,
  //   path: window.location.pathname,
  // });

  if (!isAuthenticated) {
    // console.log("🚫 Not authenticated, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  // Special case: Super admin can access everything
  if (currentUser?.role === "super_admin") {
    // console.log("👑 Super admin - full access granted");
    return children;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(currentUser?.role)) {
    // console.log("⛔ Role not allowed, redirecting to unauthorized");
    return <Navigate to="/unauthorized" replace />;
  }

  // console.log("✅ Access granted");
  return children;
};

export default ProtectedRoute;
